module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-206.7b1812a0.svg";